import { Route, Switch, useLocation, useRouteMatch } from "react-router-dom";
import DefaultDashboardPage from "../DefaultDashboardPage";
import ModulesPage from "../ModulesPage";

export default function DashboardRoutes(props: any) {
    let { path } = useRouteMatch();
    // let { module }: any = useParams();
    let location = useLocation();

    return (
        <div>
            {/* <TransitionGroup>
             */}
             {/* <TransitionGroup>
            <CSSTransition key={location.key} classNames="anim-fade" timeout={200} unmountOnExit> */}
                <Switch location={location}>
                    <Route exact path={path} component={() => <ModulesPage />}></Route>
                    <Route path={`${path}/:module`}>
                        <DefaultDashboardPage hiddenSidebar={props.hiddenSidebar} />
                    </Route>
                </Switch>
            {/* </CSSTransition>
            </TransitionGroup> */}
            {/* </CSSTransition>
            </TransitionGroup> */}
        </div>
    );
}
